'use strict';

const bannerCarouselA11y = require('friartux/components/bannerCarouselA11y');

const SELECTORS = {
    topBannerBar: '.top-banner-bar'
}

$(document).ready(function () {
    let $topBannerBar = $(SELECTORS.topBannerBar);
    if ($topBannerBar.length <= 0) {
        return;
    }

    var { tns } = require("tiny-slider");

    //Anonymous Function used in the Page Designer Slider Blog Component
    var slider = tns({
        container: SELECTORS.topBannerBar,
        items: 1,
        slideBy: 1,
        axis: 'vertical',
        swipeAngle: true,
        speed: 400,
        autoplayTimeout: 6000,
        mouseDrag: true,
        autoplay: true,
        nav:false,
        arrows:false,
        controls:false,
        autoplayButton: false,
        rewind: false,
        gutter: 0,
        autoHeight: false,
        autoplayButtonOutput: false
    });

    // Keeps the tab order on the slide that is actually on screen, names the generic
    // "View Details" links after their own banner message, and holds the rotation
    // while focus is inside the banner. See components/bannerCarouselA11y.
    bannerCarouselA11y.init(slider);
});
